import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Modal, ModalContent, ModalTrigger, useModalState } from "../../../components/Modal/modalWithoutAnimation";
export const Selector = ({ children }) => {
    return (_jsx(Modal, { children: children }));
};
export const useSelectorState = () => {
    return useModalState();
};
export const SelectorContent = forwardRef((props, ref) => {
    const { children, header } = props;
    return (_jsx(ModalContent, { header: header, ref: ref, children: children }));
});
SelectorContent.displayName = 'SelectorContent';
export const SelectorTrigger = (props) => {
    return _jsx(ModalTrigger, { ...props });
};
